import { Directive, OnDestroy, ViewContainerRef, inject } from '@angular/core';
@Directive({ selector: '[miqWizardProjector]' })
export class WizardProjectorDirective implements OnDestroy {
  public viewContainerRef = inject(ViewContainerRef);
  ngOnDestroy(): void {
    if (this.viewContainerRef) {
      this.viewContainerRef.clear();
      this.viewContainerRef = null;
    }
  }
}
